

export const bringAPI = val => {
    if (!/^\d{4}$/.test(val)) {
        return;
    }
    const URL = `https://api.bring.com/shippingguide/api/postalCode.json?clientUrl=localhost:3000&pnr=${val}`
    return fetch(URL).then(res => res.json())

}